export const Assets = {
  p1preview: require('../components/img/p1preview.jpg'),
  p2preview: require('../components/img/p2preview.jpg'),
  p2detail: require('../components/img/p2detail.jpg'),
  p3preview: require('../components/img/p3preview.png'),
  p3detail: require('../components/img/p3detail.png'),
  p4preview: require('../components/img/p4preview.png'),
  p5preview: require('../components/img/p5preview.jpg'),
  p5detail: require('../components/img/p5detail.png'),
  p6preview: require('../components/img/p6preview.jpg'),
  p6detail: require('../components/img/p6detail.jpg'),
  profileImg: require('../components/img/profile.jpg')
}